import http from './httpService'; 
import {apiUrl} from './../config/config.json';
const apiEndpoint = apiUrl+'/diseaseconditions';


  function diseasesconditionUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getAcupunctures() {
    return http.get(apiEndpoint);
  }
  
  export function getAcupuncture(Id) {
    return http.get(diseasesconditionUrl(Id));
  }
  
  export function saveAcupuncture(diseasescondition) {
    //clone
    const body = { ...diseasescondition };
    console.log(body);
   //update
   if (diseasescondition.id) {
     //delete _id
     delete body.id;
     return http.put(diseasesconditionUrl(diseasescondition.id),body);
   }
 
   //add a new diseasescondition
   return http.post(apiEndpoint, diseasescondition);
 }
  
  //delete diseasesconditions
  export function deleteAcupuncture(Id) {
    return http.delete(diseasesconditionUrl(Id));
  }  